import IFrameView from "../view/iframe.js";

export default class IFrameLoader {
  constructor(elements) {
    this._elements = elements;
    this._views = [];
  }

  init() {
    if (!this._elements) {
      return;
    }

    Array
      .from(this._elements)
      .forEach((element) => {
        const view = new IFrameView(element);
        this._views.push(view);
      });

    this._views.forEach((view) => {
      this._observeElement(view);
    });
  }

  _observeElement(view) {
    const observerOptions = {
      root: null
    };

    const observerCallback = (entries, observer) => {
      let isIntersecting = false;

      entries.forEach((entry) => {
        if (isIntersecting === true) {
          return;
        }

        isIntersecting = entry.isIntersecting;
      });

      if (isIntersecting === false) {
        return;
      }

      observer.unobserve(view.getElement());
      view.setSrc();
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(view.getElement());
  }
}
